export default [
    /* 消息模版 start */
    {
        path: 'templates',
        name: 'marketing_templates',
        meta: {
            // access: ['AUTH_MESSAGE_TEMPLATE'],
            title: 'marketing_templates',
            icon: 'icon-guangbo',
            notPageView: true,
        },
        component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/index.vue'),
        children: [
            /* whatsapp 模版 start */
            {
                path: 'whatsapp',
                name: 'marketing_templates_whatsapp',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_WHATSAPP_TEMPLATE'],
                    title: 'marketing_templates_whatsapp',
                    icon: 'icon-guangbo',
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/whatsapp/templates.vue'),
            },
            {
                path: 'whatsapp/create',
                name: 'marketing_templates_whatsapp_create',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_WHATSAPP_TEMPLATE'],
                    title: 'marketing_broadcast_create_whatsapp_templates',
                    icon: 'icon-a-xiaoxiguangbo2',
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/whatsapp/create.vue'),
            },
            /* whatsapp 模版 end */

            /* email 模版 start */
            {
                path: 'email',
                name: 'marketing_templates_email',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_EMAIL_TEMPLATE'],
                    title: 'marketing_templates_email',
                    icon: 'icon-guangbo',
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/email/index.vue'),
            },
            {
                path: 'email/create/:template_id*',
                name: 'marketing_templates_email_create',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_EMAIL_TEMPLATE'],
                    title: 'marketing_templates_email_edit',
                    icon: 'icon-guangbo',
                },
                props: (route: any) => {
                    return {
                        ...route.query,
                        ...route.params,
                    };
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/email/EditTemplate.vue'),
            },
            {
                path: 'email/edit/:template_id*',
                name: 'marketing_templates_email_edit',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_EMAIL_TEMPLATE'],
                    title: 'marketing_templates_email_edit',
                    icon: 'icon-guangbo',
                },
                props: (route: any) => {
                    return {
                        ...route.query,
                        ...route.params,
                    };
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/email/EditTemplate.vue'),
            },
            {
                path: 'email/copy/:template_id*',
                name: 'marketing_templates_email_copy',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_EMAIL_TEMPLATE'],
                    title: 'marketing_templates_email_copy',
                    icon: 'icon-guangbo',
                },
                props: (route: any) => {
                    return {
                        ...route.query,
                        ...route.params,
                    };
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/email/EditTemplate.vue'),
            },
            /* email 模版 end */

            /* messenger 模版 start */
            {
                path: 'messenger',
                name: 'marketing_templates_messenger',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_MESSENGER_TEMPLATE'],
                    title: 'marketing_templates_messenger',
                    icon: 'icon-guangbo',
                },
                component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/messenger/index.vue'),
            },
            /* messenger 模版 end */
        ],
    },
    {
        path: 'messenger/create/:template_id*',
        name: 'marketing_templates_messenger_create',
        meta: {
            hideInMenu: true,
            access: ['AUTH_MESSENGER_TEMPLATE'],
            title: 'marketing_templates_messenger',
            icon: 'icon-guangbo',
        },
        component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/messenger/create.vue'),
    },
    {
        path: 'messenger/copy/:template_id*',
        name: 'marketing_templates_messenger_copy',
        meta: {
            hideInMenu: true,
            access: ['AUTH_MESSENGER_TEMPLATE'],
            title: 'marketing_templates_messenger',
            icon: 'icon-guangbo',
        },
        component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/messenger/create.vue'),
    },
    {
        path: 'messenger/edit/:template_id*',
        name: 'marketing_templates_messenger_edit',
        meta: {
            hideInMenu: true,
            access: ['AUTH_MESSENGER_TEMPLATE'],
            title: 'marketing_templates_messenger',
            icon: 'icon-guangbo',
        },
        component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/messenger/create.vue'),
    },
    {
        path: 'messenger/look/:template_id*',
        name: 'marketing_templates_messenger_look',
        meta: {
            hideInMenu: true,
            access: ['AUTH_MESSENGER_TEMPLATE'],
            title: 'marketing_templates_messenger',
            icon: 'icon-guangbo',
        },
        component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/messenger/create.vue'),
    },
    {
        path: 'messenger/library',
        name: 'marketing_templates_messenger_library',
        meta: {
            hideInMenu: true,
            access: ['AUTH_MESSENGER_TEMPLATE'],
            title: 'marketing_templates_messenger',
            icon: 'icon-guangbo',
        },
        component: () => import(/* webpackChunkName: "broadcast" */ '@/views/main/broadcast/templates/messenger/library.vue'),
    },
];
